"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRequest = void 0;
const error_request_1 = __importDefault(require("../error/error.request"));
const axios_1 = __importDefault(require("axios"));
axios_1.default.defaults.baseURL = "https://ws.audioscrobbler.com";
class ApiRequest {
    lastFm(method, apiKey, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get("/2.0", {
                    params: Object.assign(Object.assign({}, params), { method, format: "json", api_key: apiKey }),
                });
                return data;
            }
            catch (err) {
                throw new error_request_1.default(err);
            }
        });
    }
}
exports.ApiRequest = ApiRequest;
//# sourceMappingURL=request.service.js.map